export default "__VITE_ASSET__B9EoxV0p__"